import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Cookies are the primary auth mechanism (set by backend on OAuth).
// As a fallback (e.g. environments that block injected cookies), attach a
// bearer token from localStorage if present — backend checks cookie first, then header.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
